export const OBJECT_TAGS = {
  LABEL: 'label',
  DRAWING_LINES: 'drawing-line'
} as const;
